import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class OlimpiaService {

  constructor(private httpClient: HttpClient) { }

  getValidation(identificationType: string, numDoc: string, email: string, celular: string) {
    return this.httpClient.post(`${ environment.serverUrl }/app/olimpia/validateRequest`, {identificationType, numDoc, email, celular});
  }

  verifyValidation(processGuid: string) {
    return this.httpClient.post(`${ environment.serverUrl }/app/olimpia/verifyValidate`, {processGuid});
  }

  setValidate(barcodeData: any) {
    return this.httpClient.post(`${ environment.serverUrl }/app/olimpia/setValidate`, {barcodeData});
  }

  getWhatsappValidation() {
    return this.httpClient.get(`${ environment.serverUrl }/app/whatsapp/validateRequest`);
  }

  verifyWhatsappValidation(processGuid: string) {
    return this.httpClient.post(`${ environment.serverUrl }/app/whatsapp/verifyValidate`, {processGuid});
  }
}


